/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { InjectionToken } from '@angular/core';

export const DefaultFcResponsiveAgDialogOptionConfig = 
    new InjectionToken<FcResponsiveAgDialogOptions>('default-simple-modal.config');

export interface FcResponsiveAgDialogOptions {
    bodyClass: string;
    wrapperDefaultClasses: string;
    wrapperClass: string;
    autoFocus: boolean;
}

export type FcResponsiveAgDialogOptionsOverrides = Partial<FcResponsiveAgDialogOptions>;

export const defaultFcResponsiveAgDialogOptions: FcResponsiveAgDialogOptions = {
    bodyClass: 'modal-open',
    wrapperDefaultClasses: 'modal fade-anim',
    wrapperClass: 'in',
    autoFocus: false
};